import * as React from "react";
const SvgArrowLeftOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M24 0v24H0V0h24z" opacity={0.87} />
    <path d="m14 7-5 5 5 5V7z" />
  </svg>
);
export default SvgArrowLeftOutlined;
